import { Controller, useFormContext } from 'react-hook-form';

import { TextInput } from 'components/DesignSystem/TextInput';
import { FormProps } from 'components/widgets/CustomerProfile/CustomerProfile';

export const OpcHost = () => {
    const methods = useFormContext<FormProps>();
    return (
        <Controller
            render={({ field }) => <TextInput {...field} label={'OPC Host'} />}
            name={`opcHost`}
            control={methods.control}
        />
    );
};
